<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：ファイル登録完了画面(STFMFM02C28AddFileComfirm)                                                               _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div class="overlay" :class="[isComfirmDlgFlagDlgShow ? showClass : hideClass]" id="popup-import" ref="content">
    <div class="popup" style="width: 660px">
      <div class="popup-head">ファイル登録完了</div>
      <div class="popup-body blue" v-if="!isUploadFlg">
        <p>処理が完了しました。続けて取引情報等の確認・登録を行います。</p>
        <ul class="note">
          <li>電子帳簿保存法を満たすためには取引情報の登録が必要です。<br>取引情報の登録が未完了のファイルについては、［ファイル一覧］画面にて<img
              src="../assets/images/denchouhou/icon_alert_rd.png" style="width:20px;height:20px;min-width:20px;min-height:20px" alt="プ取引情報の登録が未完了">アイコンが表示されます。
          </li>
        </ul>
      </div>
      <div class="popup-body blue" v-if="isUploadFlg">
        <p>処理が完了しました。一部のファイルの登録に失敗したため、次の画面でご確認ください。<br>ファイルの登録が成功したファイルについては、続けて取引情報等の確認・登録を行います。</p>
        <ul class="note">
          <li>電子帳簿保存法を満たすためには取引情報の登録が必要です。<br>取引情報の登録が未完了のファイルについては、「ファイル一覧」画面にて<img
              src="../assets/images/denchouhou/icon_alert_rd.png" style="width:20px;height:20px;min-width:20px;min-height:20px" alt="プ取引情報の登録が未完了">アイコンが表示されます。
          </li>
        </ul>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button class="frm-btn strong frm-size-mx large" data-role="popup-close" @click="handleYes" ref="refButton"
                tabindex="1">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/util/common.js";
import { mapMutations } from "vuex";

export default {
  name: "STFMFM02C28AddFileComfirm",
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
    };
  },
  props: {
    isComfirmDlgFlagDlgShow: {
      type: Boolean,
      required: true,
      default:false
    },
    isUploadFlg: {
      type: Boolean,
      required: false,
    },
  },

  created() {
  },
  mounted() {
   
  },
  computed: {
  },
  watch: {
    isComfirmDlgFlagDlgShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
  },
  methods: {
    ...mapMutations("businessModule", ["handleBodyScrollOnModalStateChange"]),
    // **********************************************
    // * OKボタンをクリック
    // **********************************************
    handleYes() {
      window.removeEventListener("keydown",this.handeleKeydownTab)
      this.handleBodyScrollOnModalStateChange(false)
      this.$router.push({
        name: "STFMFM02C07",
        params: {}
      });
      
    },
    handeleKeydownTab(event) {
      const e = event || window.event
      if (e.keyCode === 9) {
        e.preventDefault()
        return false
      }
    },
    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.refButton.focus()
      window.addEventListener("keydown", this.handeleKeydownTab)
    },
  },
};
</script>
